import styles from "../styles/whatsapp-button.module.css";
import Image from "next/image";

export default function WhatsAppButton() {
  return (
    <>
      <div className={styles.floatingButton}>
        <Image
          src="/wa logo.png"
          alt="whatsApp button"
          width={2000}
          height={2000}
          onClick={() => {
            window.location.href =
              "http://api.whatsapp.com/send/?phone=628112002707&text=Hi,+Minlab !!&type=phone_number&app_absent=0";
          }}
          className={styles.image}
        />
      </div>
    </>
  );
}
